import React, { useContext, useEffect, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { useGameContext } from "../../libs/GameProvider";

interface GameGunpowderGameLaneProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  lane: number;
  onSuccess: () => void,
  onFail: () => void,
}

function GameGunpowderGameLane(props: GameGunpowderGameLaneProps) {
  const { playClick } = useContext(AudioContext);
  const { gameDifficulty } = useGameContext();
  const [targetStatus, setTargetStatus] = useState<'' | 'shot' | 'down' | 'disabled'>('');
  const [cursorStatus, setCursorStatus] = useState<'' | 'ignite'>('');
  const [cannonStatus, setCannonStatus] = useState<'' | 'failed'>('');
  const [cannonballStatus, setCannonballStatus] = useState<'' | 'shoot'>('');

  useEffect(() => {
    if (3 === gameDifficulty.difficulty) {
      const interval = setInterval(() => {
        if ('' === targetStatus) {
          if (Math.random() > .3) {
            setTargetStatus('disabled');
          }
        } else if ('disabled' === targetStatus) {
          setTargetStatus('');
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [gameDifficulty.difficulty, targetStatus]);

  const onCannonClick = () => {
    playClick();
    if ('' === targetStatus) {
      setCursorStatus('ignite');
      setTargetStatus('shot');
      setTimeout(() => {
        setCannonballStatus('shoot');

        setTimeout(() => {
          setTargetStatus('down');
          setCursorStatus('');
          props.onSuccess();
        }, 800);
      }, 100);
    } else {
      setCannonStatus('failed');
      setTimeout(() => {
        setCursorStatus('');
        setCannonStatus('');
      }, 300);
      props.onFail();
    }
  }

  return (
    <div className={`lane lane-${props.lane} lane-${targetStatus}`}>
      <div className={`target target-${targetStatus}`}></div>
      <div className={`cannonball cannonball-${cannonballStatus}`}></div>
      <div className={`cannon cannon-${cannonStatus}`} onClick={onCannonClick}></div>
      <div className={`cursor cursor-${cursorStatus}`}></div>
    </div>
  )
}

export default GameGunpowderGameLane;
